import styled from '@emotion/styled';

const ButtonWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexBasis: 'auto',
  flexDirection: 'column',
  textTransform: 'uppercase',
  alignItems: 'flex-end',
  justifyContent: 'center',
  minWidth: 110,
  [theme.mediaQuery.desktopAndUp]: {
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: 130,
    flexDirection: 'row',
    paddingLeft: theme.spacing.small,
    paddingRight: theme.spacing.small,
  },
}));

export default ButtonWrapper;
